import { render } from "./ConfigGate.vue?vue&type=template&id=9a7a654a"
import script from "./ConfigGate.vue?vue&type=script&lang=js"
export * from "./ConfigGate.vue?vue&type=script&lang=js"

import "./ConfigGate.vue?vue&type=style&index=0&id=9a7a654a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__